import imageCompression from "browser-image-compression";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { IoArrowBackSharp } from "react-icons/io5";
import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  applyClassToCharacters,
  convertToDateString,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { addMember } from "../ApiMember";
import moment from "moment";
import swal from "sweetalert";
import { GetSelectedLanguage } from "../../helper/Method";
import { useTranslation } from "react-i18next";
import "moment/locale/ur";
import { encryptStorage } from "../../../constants/EncryptStorage";

const MarkRafiqAsExRequest = ({ history }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const reason = location.state?.reason;
  const memberId = location.state?.memberId;
  const date = location.state?.date;
  const referenceNote = location.state?.referenceNote;
  const unitTypeName = encryptStorage.getItem("unitTypeName");

  moment.locale("ur");

  const [tarafiIjtimaAttendingDate, setTarafiIjtimaAttendingDate] =
    useState(null);
  const [fehmDeenAttendingDate, setFehmDeenAttendingDate] = useState(null);
  const [lastMemberContactWithUnit, setLastMemberContactWithUnit] =
    useState(null);
  const [lastContactWithMemberByUnit, setLastContactWithMemberByUnit] =
    useState(null);
  const [lastFundDate, setLastFundDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [file, setFile] = useState();
  const [values, setValues] = useState({
    memberName: "",
    memberFatherName: "",
    memberRegNo: "",
    joiningDate: "",
    joinedOnWhoseInvitation: "",
    tarafiIjtimaAttendingDate: "",
    fehmDeenAttendingDate: "",
    mubtadiMultazimCourseAttendingDate: "",
    mubtadiMultazimCourseAttendingLocation: "",
    wasMemberActiveBefore: "",
    memberInactivityReasons: "",
    memberIncludedInAnyUsra: "",
    lastFundDate: "",
    lastMemberContactWithUnit: "",
    lastContactWithMemberByUnit: "",
    isPostalAddressChangedAfterJoining: "",
    memberCurrentContactDetails: "",
    whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: false,
    whatReasonToLeftFeltOnMeetingMemberBusy: false,
    whatReasonToLeftFeltOnMeetingMemberPressureFromHome: false,
    whatReasonToLeftFeltOnMeetingMemberFinancialProblem: false,
    whatReasonToLeftFeltOnMeetingMemberOther: "",
    wasMemberContactedByMemberWhoInvited: "",
    requestFromUnitForExit: false,
    requestFromMemberPersonally: false,
    requestFromMemberInWrittenForm: false,
    muqamiAmeerName: "",
    dateOfRequest: date ? date : "",
    ameerHalqaName: "",
    ameerHalqaFeedback: "",
    naibNazimAllaName: "",
    writtenLetterSentToRafiqDate: "",
    answerFromRafiq: false,
    nazimAllaName: "",
    markAsExReasonId: reason.value,
    markAsExReason: reason.label,
    referenceNote: referenceNote,
  });

  useEffect(() => {
    setLoading(true);
    addMember()
      .GetMarkMemberAsExFormData(memberId)
      .then((res) => {
        setValues({
          ...values,
          memberId: res.data.memberId,
          memberName: res.data.memberName,
          memberFatherName: res.data.memberFatherName,
          memberRegNo: res.data.memberRegNo,
          joiningDate: res.data.joiningDate,
          mubtadiMultazimCourseAttendingDate:
            res.data.mubtadiMultazimCourseAttendingDate,
          mubtadiMultazimCourseAttendingLocation:
            res.data.mubtadiMultazimCourseAttendingLocation,
          tarafiIjtimaAttendingDate: res.data.tarafiIjtimaAttendingDate,
          fehmDeenAttendingDate: res.data.fehmDeenAttendingDate,
          lastFundDate: res.data.lastFundDate,
          muqamiAmeerName: res.data.muqamiAmeerName,
          halqaName: res.data.halqaName,
          muqamiTanzeemName: res.data.muqamiTanzeemName,
          isPostalAddressChangedAfterJoining:
            res.data.isPostalAddressChangedAfterJoining,
          memberCurrentContactDetails: res.data.memberCurrentContactDetails,
          ameerHalqaName: res.data.ameerHalqaName,
          naibNazimAllaName: res.data.naibNazimAllaName,
          nazimAllaName: res.data.nazimAllaName
        });
        const parseDate = (d) =>
          d && d !== "0001-01-01" && !isNaN(new Date(d)) ? new Date(d) : null;

        setLastFundDate(parseDate(res.data.lastFundDate));
        setFehmDeenAttendingDate(parseDate(res.data.fehmDeenAttendingDate));
        setTarafiIjtimaAttendingDate(
          parseDate(res.data.tarafiIjtimaAttendingDate)
        );

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [memberId]);

  const handleUpload = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.size < 10 * 1024 * 1024) {
      const options = {
        maxSizeMB: 10,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      let compressedFile = selectedFile;
      if (!selectedFile.type.includes("pdf")) {
        compressedFile = await imageCompression(selectedFile, options);
      }

      setFile(compressedFile);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: type === "checkbox" || type === "radio" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setButtonDisable(true);

    // Preprocess date fields
    values.markAsExReasonId = reason.value;
    values.markAsExReason = reason.label;
    values.dateOfRequest = convertToDateString(date);
    values.tarafiIjtimaAttendingDate = convertToDateString(
      tarafiIjtimaAttendingDate
    );
    values.fehmDeenAttendingDate = convertToDateString(fehmDeenAttendingDate);
    values.lastMemberContactWithUnit = convertToDateString(
      lastMemberContactWithUnit
    );
    values.lastContactWithMemberByUnit = convertToDateString(
      lastContactWithMemberByUnit
    );
    values.lastFundDate =
      values.lastFundDate !== "" && values.lastFundDate !== null
        ? values.lastFundDate
        : lastFundDate
        ? ` ${moment(lastFundDate).format("MMMM ، YYYY")}`
        : " ";

    // Build FormData
    const formData = new FormData();
    Object.entries(values).forEach(([key, val]) => {
      formData.append(key, val ?? "");
    });

    // Append the file (if selected)
    if (File) {
      formData.append("File", file); // 'File' should match your backend property name
    }

    addMember()
      .MarkRafiqAsEx(formData)
      .then((res) => {
        if (res.data === "member_mark_as_ex_request_exists") {
          swal({
            title: t("member_mark_as_ex_request_exists"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
        } else {
          swal({
            title: t(res.data),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "success",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
        }
        setLoading(false);
        setButtonDisable(false);
        history.goBack();
      })
      .catch((err) => {
        setLoading(false);
        setButtonDisable(false);
        swal({
          title: err.message || "Something went wrong",
          icon: "error",
          buttons: "OK",
        });
        console.error(err);
      });
  };

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <Card className="mb-4">
        <CardHeader className="bg-white d-flex justify-content-between align-items-center py-3">
          <h4 className="mb-0" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
            {applyClassToCharacters(
              getStringFromJSX(
                <GetLanguageString
                  props="member_mark_as_ex_request_title"
                  value={
                    reason?.label?.split(":")[0] || "Mark as Ex-Member Request"
                  }
                />
              ),
              "ur"
            )}
          </h4>
          <Button
            color="default"
            className="d-flex align-items-center"
            onClick={() => history.goBack()}
          >
            <IoArrowBackSharp className="me-2" color="#18A689" size={15} />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </CardHeader>
        <CardBody>
          {!loading ? (
            <Form onSubmit={handleSubmit}>
              <div className="mb-4">
                <h4
                  className="ur mb-3"
                  style={{
                    color: "#18A689",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "8px",
                  }}
                >
                  مقامی تنظیم کی سطح پر
                </h4>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString props={"common_name"} />
                      </Label>
                      <Input
                        type="text"
                        name="memberName"
                        disabled
                        className={`form-control ${
                          isUrdu(values.memberName) ? "ur" : ""
                        }`}
                        value={values.memberName}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString props={"member_father_name"} />
                      </Label>
                      <Input
                        type="text"
                        name="memberFatherName"
                        disabled
                        className={`form-control ${
                          isUrdu(values.memberFatherName) ? "ur" : ""
                        }`}
                        value={values.memberFatherName}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString props={"member_reg_number"} />
                      </Label>
                      <Input
                        type="text"
                        name="memberRegNo"
                        disabled
                        className={`form-control ${
                          isUrdu(values.memberRegNo) ? "ur" : ""
                        }`}
                        value={getStringFromJSX(
                          applyClassToCharacters(values.memberRegNo, "ur")
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr></hr>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString props={"member_joining_date"} />
                      </Label>
                      <Input
                        type="text"
                        name="joiningDate"
                        disabled
                        className={`form-control ${
                          isUrdu(values.joiningDate) ? "ur" : ""
                        }`}
                        value={values.joiningDate}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        کس کی دعوت پر تنظیم اسلامی میں شمولیت اختیار کی؟
                      </Label>
                      <Input
                        type="text"
                        name="joinedOnWhoseInvitation"
                        className={`form-control ${
                          isUrdu(values.joinedOnWhoseInvitation) ? "ur" : ""
                        }`}
                        value={values.joinedOnWhoseInvitation}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق کی تعارفی اجتماع میں شرکت کی تاریخ
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        maxDate={new Date()}
                        className="form-control"
                        selected={tarafiIjtimaAttendingDate}
                        onChange={(date) => setTarafiIjtimaAttendingDate(date)}
                        dateFormat="dd/MM/yyyy"
                        disabled={values.tarafiIjtimaAttendingDate}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr></hr>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق کی فہم دین کورس میں شرکت کی تاریخ
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        maxDate={new Date()}
                        className="form-control"
                        selected={fehmDeenAttendingDate}
                        onChange={(date) => setFehmDeenAttendingDate(date)}
                        dateFormat="dd/MM/yyyy"
                        disabled={values.fehmDeenAttendingDate}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="8">
                    <h5 className="form-label ur">
                      مبتدی/ملتزم کورس میں اگر شرکت کی ہے تو
                    </h5>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label className="form-label ur">تاریخ</Label>
                          <Input
                            type="text"
                            name="mubtadiMultazimCourseAttendingDate"
                            disabled
                            className={"form-control"}
                            value={
                              values.mubtadiMultazimCourseAttendingDate
                                ? moment(
                                    convertUTCToLocalTime(
                                      values.mubtadiMultazimCourseAttendingDate
                                    )
                                  ).format("DD/MM/yyyy")
                                : ""
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label className="form-label ur">مقام</Label>
                          <Input
                            type="text"
                            name="joinedOnWhoseInvitation"
                            className={`form-control ${
                              isUrdu(
                                values.mubtadiMultazimCourseAttendingLocation
                              )
                                ? "ur"
                                : ""
                            }`}
                            value={
                              values.mubtadiMultazimCourseAttendingLocation
                            }
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <hr></hr>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        کیا متعلقہ رفیق تنظیم میں شمولیت کے بعد ہی سے غیر فعال
                        رہے یا پھلے کسی دور میں وو فعال بھی تھے؟
                      </Label>
                      <Input
                        type="text"
                        name="wasMemberActiveBefore"
                        className={`form-control ${
                          isUrdu(values.wasMemberActiveBefore) ? "ur" : ""
                        }`}
                        value={values.wasMemberActiveBefore}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        اگر رفیق مسلسل غیر فعال رہے تو اس کی بنیادی وجوہات کیا
                        محسوس کی گئیں
                      </Label>
                      <Input
                        type="text"
                        name="memberInactivityReasons"
                        className={`form-control ${
                          isUrdu(values.memberInactivityReasons) ? "ur" : ""
                        }`}
                        value={values.memberInactivityReasons}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        کیا رفیق کو شمولیت کے وقت کسی اسره میں شامل کیا گیا ؟
                      </Label>
                      <Input
                        type="text"
                        name="memberIncludedInAnyUsra"
                        className={`form-control ${
                          isUrdu(values.memberIncludedInAnyUsra) ? "ur" : ""
                        }`}
                        value={values.memberIncludedInAnyUsra}
                        onChange={handleInputChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr></hr>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق نے آخری مرتبہ انفاق کب جمع کرایا؟
                      </Label>
                      {values.lastFundDate !== "" &&
                      values.lastFundDate !== null ? (
                        <Input
                          type="text"
                          name="lastFundDate"
                          className={`form-control ${
                            isUrdu(values.lastFundDate) ? "ur" : ""
                          }`}
                          value={values.lastFundDate}
                          disabled
                        />
                      ) : (
                        <>
                          <DatePicker
                            showMonthYearPicker
                            showYearDropdown
                            selected={lastFundDate}
                            maxDate={new Date()}
                            onChange={(date) => setLastFundDate(date)}
                            className="form-control"
                            dateFormat="MMMM, yyyy" // placeholder format; we'll display it in Urdu below
                            placeholderText="MMMM, yyyy"
                          />
                          <div
                            className="ur"
                            style={{
                              fontSize: "18px",
                              marginTop: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            {lastFundDate
                              ? ` ${moment(lastFundDate).format("MMMM ، YYYY")}`
                              : " "}
                          </div>
                        </>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق کی طرف سے نظم سے آخری بار رابطہ کب ہوا؟
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        maxDate={new Date()}
                        className="form-control"
                        selected={lastMemberContactWithUnit}
                        onChange={(date) => setLastMemberContactWithUnit(date)}
                        dateFormat="dd/MM/yyyy"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label className="form-label ur">
                        نظم نے رفیق سے آخری بار رابطہ کب کیا؟
                      </Label>
                      <DatePicker
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="dd/mm/yyyy"
                        maxDate={new Date()}
                        className="form-control"
                        selected={lastContactWithMemberByUnit}
                        onChange={(date) =>
                          setLastContactWithMemberByUnit(date)
                        }
                        dateFormat="dd/MM/yyyy"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <hr></hr>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق کا موجودہ پوسٹل ایڈریس اور شمولیت کے وقت کے ایڈریس
                        میں کوئی تبدیلی واقع ہوئی؟
                      </Label>
                      <Input
                        type="text"
                        name="isPostalAddressChangedAfterJoining"
                        className={`form-control ${
                          isUrdu(values.isPostalAddressChangedAfterJoining)
                            ? "ur"
                            : ""
                        }`}
                        value={values.isPostalAddressChangedAfterJoining}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="form-label ur">
                        رفیق کا موجودہ رابطہ (پوسٹل ایڈریس و فون نمبر وغیرہ)
                      </Label>
                      <Input
                        type="textarea"
                        name="memberCurrentContactDetails"
                        className={`form-control ${
                          isUrdu(values.memberCurrentContactDetails) ? "ur" : ""
                        }`}
                        value={values.memberCurrentContactDetails}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <hr></hr>
                <Row>
                  <Col md="7">
                    <FormGroup>
                      <Label className="form-label ur" style={{ fontSize: 15 }}>
                        مقامی نظم کی جانب سے جو متعلقہ رفیق سے ملاقات کی گئی اس
                        میں کیا محسوس کیا گیا
                      </Label>
                      <Row>
                        <Col md="2">
                          <Input
                            type="radio"
                            name="whatReasonToLeftFeltOnMeetingMemberConflictOfInterest"
                            id="whatReasonToLeftFeltOnMeetingMemberConflictOfInterest"
                            className="form-check-input"
                            checked={
                              values.whatReasonToLeftFeltOnMeetingMemberConflictOfInterest
                            }
                            onChange={() =>
                              setValues((prev) => ({
                                ...prev,
                                whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: true,
                                whatReasonToLeftFeltOnMeetingMemberBusy: false,
                                whatReasonToLeftFeltOnMeetingMemberPressureFromHome: false,
                                whatReasonToLeftFeltOnMeetingMemberFinancialProblem: false,
                                whatReasonToLeftFeltOnMeetingMemberOther: "",
                              }))
                            }
                          />
                          &nbsp;&nbsp;
                          <Label
                            check
                            className="form-check-label ur"
                            htmlFor="whatReasonToLeftFeltOnMeetingMemberConflictOfInterest"
                          >
                            فکری ناپختگی
                          </Label>
                        </Col>

                        <Col md="2">
                          <Input
                            type="radio"
                            name="whatReasonToLeftFeltOnMeetingMemberBusy"
                            id="whatReasonToLeftFeltOnMeetingMemberBusy"
                            className="form-check-input"
                            checked={
                              values.whatReasonToLeftFeltOnMeetingMemberBusy
                            }
                            onChange={() =>
                              setValues((prev) => ({
                                ...prev,
                                whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: false,
                                whatReasonToLeftFeltOnMeetingMemberBusy: true,
                                whatReasonToLeftFeltOnMeetingMemberPressureFromHome: false,
                                whatReasonToLeftFeltOnMeetingMemberFinancialProblem: false,
                                whatReasonToLeftFeltOnMeetingMemberOther: "",
                              }))
                            }
                          />
                          &nbsp;&nbsp;
                          <Label
                            check
                            className="form-check-label ur"
                            htmlFor="whatReasonToLeftFeltOnMeetingMemberBusy"
                          >
                            مصروفیت
                          </Label>
                        </Col>

                        <Col md="2">
                          <Input
                            type="radio"
                            name="whatReasonToLeftFeltOnMeetingMemberPressureFromHome"
                            id="whatReasonToLeftFeltOnMeetingMemberPressureFromHome"
                            className="form-check-input"
                            checked={
                              values.whatReasonToLeftFeltOnMeetingMemberPressureFromHome
                            }
                            onChange={() =>
                              setValues((prev) => ({
                                ...prev,
                                whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: false,
                                whatReasonToLeftFeltOnMeetingMemberBusy: false,
                                whatReasonToLeftFeltOnMeetingMemberPressureFromHome: true,
                                whatReasonToLeftFeltOnMeetingMemberFinancialProblem: false,
                                whatReasonToLeftFeltOnMeetingMemberOther: "",
                              }))
                            }
                          />
                          &nbsp;&nbsp;
                          <Label
                            check
                            className="form-check-label ur"
                            htmlFor="whatReasonToLeftFeltOnMeetingMemberPressureFromHome"
                          >
                            گھریلو دباؤ
                          </Label>
                        </Col>

                        <Col md="2">
                          <Input
                            type="radio"
                            name="whatReasonToLeftFeltOnMeetingMemberFinancialProblem"
                            id="whatReasonToLeftFeltOnMeetingMemberFinancialProblem"
                            className="form-check-input"
                            checked={
                              values.whatReasonToLeftFeltOnMeetingMemberFinancialProblem
                            }
                            onChange={() =>
                              setValues((prev) => ({
                                ...prev,
                                whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: false,
                                whatReasonToLeftFeltOnMeetingMemberBusy: false,
                                whatReasonToLeftFeltOnMeetingMemberPressureFromHome: false,
                                whatReasonToLeftFeltOnMeetingMemberFinancialProblem: true,
                                whatReasonToLeftFeltOnMeetingMemberOther: "",
                              }))
                            }
                          />
                          &nbsp;&nbsp;
                          <Label
                            check
                            className="form-check-label ur"
                            htmlFor="whatReasonToLeftFeltOnMeetingMemberFinancialProblem"
                          >
                            معاشی حالات
                          </Label>
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;
                          <span className="ur">یا دیگر</span>
                        </Col>

                        <Col md="4">
                          <Input
                            type="text"
                            name="whatReasonToLeftFeltOnMeetingMemberOther"
                            className={`form-control ${
                              isUrdu(
                                values.whatReasonToLeftFeltOnMeetingMemberOther
                              )
                                ? "ur"
                                : ""
                            }`}
                            value={
                              values.whatReasonToLeftFeltOnMeetingMemberOther
                            }
                            onChange={(e) =>
                              setValues((prev) => ({
                                ...prev,

                                whatReasonToLeftFeltOnMeetingMemberConflictOfInterest: false,
                                whatReasonToLeftFeltOnMeetingMemberBusy: false,
                                whatReasonToLeftFeltOnMeetingMemberPressureFromHome: false,
                                whatReasonToLeftFeltOnMeetingMemberFinancialProblem: false,
                                whatReasonToLeftFeltOnMeetingMemberOther:
                                  e.target.value,
                              }))
                            }
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </Col>
                  <Col md="5">
                    <FormGroup>
                      <Label className="form-label ur">
                        اگر کسی رفیق کی دعوت پر متعلقہ رفیق نے تنظیم میں شمولیت
                        اختیار کی تھی تو کیا اس رفیق کے ذریعہ رابطہ کی کوشش کی
                        گئی
                      </Label>
                      <Input
                        type="text"
                        name="wasMemberContactedByMemberWhoInvited"
                        className={`form-control ${
                          isUrdu(values.wasMemberContactedByMemberWhoInvited)
                            ? "ur"
                            : ""
                        }`}
                        value={values.wasMemberContactedByMemberWhoInvited}
                        onChange={(e) =>
                          setValues((prev) => ({
                            ...prev,
                            wasMemberContactedByMemberWhoInvited:
                              e.target.value,
                          }))
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <hr></hr>
                <Row>
                  <Col md="3">
                    <Input
                      type="radio"
                      name="requestFromUnitForExit"
                      id="requestFromUnitForExit"
                      className="form-check-input"
                      checked={values.requestFromUnitForExit}
                      onChange={() =>
                        setValues({
                          ...values,
                          requestFromUnitForExit: true,
                          requestFromMemberPersonally: false,
                          requestFromMemberInWrittenForm: false,
                        })
                      }
                    />
                    &nbsp;&nbsp;
                    <Label
                      check
                      className="form-check-label ur"
                      htmlFor="requestFromUnitForExit"
                    >
                      نظم کی جانب سے اخراج کی سفارش
                    </Label>
                  </Col>

                  <Col md="3">
                    <Input
                      type="radio"
                      name="requestFromMemberPersonally"
                      id="requestFromMemberPersonally"
                      className="form-check-input"
                      checked={values.requestFromMemberPersonally}
                      onChange={() =>
                        setValues({
                          ...values,
                          requestFromUnitForExit: false,
                          requestFromMemberPersonally: true,
                          requestFromMemberInWrittenForm: false,
                        })
                      }
                    />
                    &nbsp;&nbsp;
                    <Label
                      check
                      className="form-check-label ur"
                      htmlFor="requestFromMemberPersonally"
                    >
                      رفیق نے از خود معذرت کی ہے
                    </Label>
                  </Col>

                  <Col md="6">
                    <Row>
                      <Col md="4">
                        <Input
                          type="radio"
                          name="requestFromMemberInWrittenForm"
                          id="requestFromMemberInWrittenForm"
                          className="form-check-input"
                          checked={values.requestFromMemberInWrittenForm}
                          onChange={() =>
                            setValues({
                              ...values,
                              requestFromUnitForExit: false,
                              requestFromMemberPersonally: false,
                              requestFromMemberInWrittenForm: true,
                            })
                          }
                        />
                        &nbsp;&nbsp;
                        <Label
                          check
                          className="form-check-label ur"
                          htmlFor="requestFromMemberInWrittenForm"
                        >
                          کیا رفیق نے معذرت تحریریطور پر کی ہے (کاپی منسلک کر
                          لیں)
                        </Label>
                      </Col>
                      <Col md="8">
                        <Input
                          type="file"
                          accept="image/*,application/pdf"
                          name="kawaifForm"
                          maxSize={10 * 1024 * 1024}
                          onChange={handleUpload}
                          disabled={!values.requestFromMemberInWrittenForm}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr></hr>
                <h4
                  className="ur mb-3"
                  style={{
                    borderBottom: "1px solid #eee",
                    paddingBottom: "8px",
                  }}
                >
                  مقامی امیر تنظیم
                </h4>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString
                          props={"quick_reports3_muqami_ameer"}
                        />
                      </Label>
                      <Input
                        type="text"
                        name="muqamiAmeerName"
                        disabled
                        className={`form-control ${
                          isUrdu(values.muqamiAmeerName) ? "ur" : ""
                        }`}
                        value={values.muqamiAmeerName}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label className="form-label">
                        <GetLanguageString
                          props={"dashboard_event_page_date"}
                        />
                      </Label>
                      <Input
                        type="text"
                        name="dateOfRequest"
                        disabled
                        className={"form-control"}
                        value={
                          values.dateOfRequest
                            ? moment(
                                convertUTCToLocalTime(values.dateOfRequest)
                              ).format("DD/MM/yyyy")
                            : "-"
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {unitTypeName === "Halqa" ? (
                  <>
                    <Row>
                      <h4
                        className="ur mb-3"
                        style={{
                          color: "#18A689",
                          borderBottom: "1px solid #eee",
                          paddingBottom: "8px",
                        }}
                      >
                        حلقہ کی سطح پر
                      </h4>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label className="form-label ur">
                            مقامی امیر نے متعلقہ رفیق تنظیم سے{" "}
                            {reason?.label?.split(":")[0]} کے جو احوال بتائے ہیں
                            آپ ان سے مطمئن ہیں، تفصیل سے آگاہ فرمائیں{" "}
                          </Label>
                          <Input
                            type="text"
                            name="ameerHalqaFeedback"
                            className={`form-control ${
                              isUrdu(values.ameerHalqaFeedback) ? "ur" : ""
                            }`}
                            value={values.ameerHalqaFeedback}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h4
                      className="ur mb-3"
                      style={{
                        borderBottom: "1px solid #eee",
                        paddingBottom: "8px",
                      }}
                    >
                      امیر حلقہ
                    </h4>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label className="form-label">
                            <GetLanguageString
                              props={"quick_reports3_ameer_halqa"}
                            />
                          </Label>
                          <Input
                            type="text"
                            name="ameerHalqaName"
                            disabled
                            className={`form-control ${
                              isUrdu(values.ameerHalqaName) ? "ur" : ""
                            }`}
                            value={values.ameerHalqaName}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label className="form-label">
                            <GetLanguageString
                              props={"dashboard_event_page_date"}
                            />
                          </Label>
                          <Input
                            type="text"
                            name="dateOfRequest"
                            disabled
                            className={"form-control"}
                            value={
                              values.dateOfRequest
                                ? moment(
                                    convertUTCToLocalTime(values.dateOfRequest)
                                  ).format("DD/MM/yyyy")
                                : "-"
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </>
                ) : null}
                <Row>
                  <Col md="4">
                    <Button color="white" onClick={() => history.goBack()}>
                      {<GetLanguageString props="common_cancel" />}
                    </Button>
                    <Button
                      color="primary"
                      disabled={buttonDisable}
                      className="m-l-sm"
                      type="submit"
                    >
                      {<GetLanguageString props="common_save_changes" />}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          ) : (
            LoadingSpinner()
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default withRouter(MarkRafiqAsExRequest);
